<template>
  <svg class="close-icon" width="32" height="31" viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line y1="-0.75" x2="18.9024" y2="-0.75" transform="matrix(0.71824 -0.695795 0.71824 0.695795 9.77734 22.624)" stroke-width="1.5"/>
    <line y1="-0.75" x2="18.9024" y2="-0.75" transform="matrix(0.71824 0.695795 -0.71824 0.695795 8.646 9.47217)" stroke-width="1.5"/>
  </svg>
</template>

<script>
export default {
  name: 'PanoramaCloseIcon'
}
</script>

<style lang="scss" scoped>
.close-icon {
  stroke: var(--panorama-text-color);
}
</style>
